import { notification } from "antd";
import { useCallback } from "react";
import { parseJwt } from "~/helpers/jwt";
import { renewToken } from "~/services/renewToken";
import { ParsedToken } from "~/types/authentication";
import { getToken } from "~/storages/token";

const fetcher = async () => {
  const data = await renewToken();
  return data?.userCompaniesInfo;
};

export const useRenewToken = () => {
  return useCallback(async () => {
    try {
      const token = getToken();
      if (token) {
        const companies = await fetcher();
        if (companies === undefined) {
          throw new Error();
        } else {
          const parsedToken: ParsedToken = parseJwt(token);
          const currentCompany = companies.find(
            (company) => company.companyId === parsedToken.groupsid,
          );
          return currentCompany?.tokenObject.token;
        }
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Unknown error occurred!, eCode: 2",
      });
      return undefined;
    }
  }, []);
};
